import { Component, Input, OnInit, ViewChild, ElementRef, AfterViewChecked } from '@angular/core';

@Component({
  selector: 'app-deepseek-chat',
  templateUrl: './deepseek-chat.component.html',
  styleUrls: ['./deepseek-chat.component.css']
})
export class DeepseekChatComponent implements OnInit, AfterViewChecked {
  @Input() reportData: any[] = [];

  // Estado del chat
  question: string = '';
  isLoading: boolean = false;
  messages: { role: 'user' | 'assistant'; content: string; isStreaming?: boolean }[] = [];

  // Controlador para abortar petición
  private abortController?: AbortController;

  // Control de visibilidad del chat (flotante)
  isChatOpen: boolean = false;

  // Referencia al contenedor de mensajes para auto-scroll
  @ViewChild('chatMessages') private chatMessagesContainer!: ElementRef;

  ngOnInit() {
    console.log('Reporte recibido en el chat:', this.reportData);
  }

  ngAfterViewChecked() {
    this.scrollToBottom();
  }

  /**
   * Alterna la visibilidad de la ventana de chat
   */
  toggleChat() {
    this.isChatOpen = !this.isChatOpen;
    // Cuando se abre, forzar scroll al final después de un breve delay
    if (this.isChatOpen) {
      setTimeout(() => this.scrollToBottom(), 100);
    }
  }

  /**
   * Cierra la ventana de chat
   */
  closeChat() {
    this.isChatOpen = false;
  }

  /**
   * Envía la pregunta al backend y maneja el streaming
   */
  askQuestion(event?: KeyboardEvent) {
    if (event) {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
      } else {
        return;
      }
    }

    const questionText = this.question.trim();
    if (!questionText || this.isLoading) return;

    // Agregar mensaje del usuario
    this.messages.push({ role: 'user', content: questionText });

    // Crear mensaje vacío para el asistente (con streaming)
    const assistantMsg: { role: 'assistant'; content: string; isStreaming: boolean } = {
      role: 'assistant',
      content: '',
      isStreaming: true
    };
    this.messages.push(assistantMsg);

    this.question = '';
    this.isLoading = true;

    // Asegurar que el chat esté abierto (por si acaso)
    this.isChatOpen = true;

    const payload = {
      report: this.reportData,
      question: questionText
    };

    if (this.abortController) {
      this.abortController.abort();
    }
    this.abortController = new AbortController();

    fetch('http://localhost:9000/deepseek/r1/report/chat/stream', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      signal: this.abortController.signal
    })
    .then(response => {
      if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
      const reader = response.body?.getReader();
      const decoder = new TextDecoder('utf-8');

      const readChunk = () => {
        reader?.read().then(({ done, value }) => {
          if (done) {
            this.finishStreaming();
            return;
          }
          const chunkText = decoder.decode(value, { stream: true });
          const currentMsg = this.messages[this.messages.length - 1];
          if (currentMsg && currentMsg.role === 'assistant') {
            currentMsg.content += chunkText;
          }
          readChunk();
        }).catch(error => {
          if (error.name === 'AbortError') {
            console.log('Petición abortada');
          } else {
            console.error('Error al leer el stream:', error);
          }
          this.finishStreaming();
        });
      };
      readChunk();
    })
    .catch(error => {
      if (error.name === 'AbortError') {
        console.log('Petición abortada');
      } else {
        console.error('Error al enviar la pregunta:', error);
        const currentMsg = this.messages[this.messages.length - 1];
        if (currentMsg && currentMsg.role === 'assistant') {
          currentMsg.content = '❌ Error al obtener respuesta. Inténtalo de nuevo.';
          currentMsg.isStreaming = false;
        }
      }
      this.isLoading = false;
    });
  }

  private finishStreaming() {
    const currentMsg = this.messages[this.messages.length - 1];
    if (currentMsg && currentMsg.role === 'assistant') {
      currentMsg.isStreaming = false;
    }
    this.isLoading = false;
    this.abortController = undefined;
  }

  private scrollToBottom() {
    try {
      if (this.chatMessagesContainer) {
        this.chatMessagesContainer.nativeElement.scrollTop =
          this.chatMessagesContainer.nativeElement.scrollHeight;
      }
    } catch (err) { }
  }
}